import { ToastContainer } from "react-toastify";
import useThemeMode from "@hooks/utils/useThemeMode";

export function Toast() {
  const { mode } = useThemeMode();

  return (
    <ToastContainer
      stacked
      position="bottom-right"
      containerId="bottom-right"
      theme={mode}
      toastStyle={{ borderRadius: "16px", overflow: "hidden" }}
    />
  );
}
